import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql, withPrefix } from 'gatsby';
import { extractRichTextStrings } from '../components/generic/RichText';

WebexHead.defaultProps = {
  lang: `en`,
  title: ``,
  description: ``,
  image: undefined,
};

export default function WebexHead({ location, lang, title, description, image }) {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
          image
        }
      }
    }
  `);

  const metaTitle = `${data.site.siteMetadata.title} | ${title}`;
  let metaDescription =
    description && typeof description === 'object' && 'raw' in description
      ? extractRichTextStrings(description)
      : description || data.site.siteMetadata.description;
  let metaImage = image || location?.origin + '/' + data.site.siteMetadata.image;
  metaImage = metaImage.indexOf('//') === 0 ? 'https:' + metaImage : metaImage;

  return (
    <Helmet
      title={metaTitle}
      htmlAttributes={{
        lang,
      }}
      link={[
        { rel: 'canonical', href: location.href },
        {
          rel: 'preconnect dns-prefetch',
          href: 'https://images.ctfassets.net',
        },
      ]}
      meta={[
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:url`,
          content: location.href,
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `image`,
          content: metaImage,
        },
        {
          property: `og:image`,
          content: metaImage,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: data.site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: metaTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:image`,
          content: metaImage,
        },
        {
          name: `twitter:site`,
          content: data.site.siteMetadata.site,
        },
      ]}
    >
      <script defer src={withPrefix('webex/common.js')} type="text/javascript" />
      <script defer src={withPrefix('webex/header.js')} type="text/javascript" />
      <script defer src={withPrefix('webex/footer.js')} type="text/javascript" />
      <script defer src={withPrefix('webex/amplitude.js')} type="text/javascript" />
      <script defer src={withPrefix('webex/amplitude-tracking.js')} type="text/javascript" />
      <script src="https://www.cisco.com/c/dam/cdc/t/ctm-core.js" type="text/javascript" />
      <script src="https://code.jquery.com/jquery-3.5.1.min.js" type="text/javascript" />
      <script src="https://cdn.staticfile.org/jquery-cookie/1.4.1/jquery.cookie.min.js" type="text/javascript" />
      <script src="https://assets.adobedtm.com/launch-EN4bb51babc17241a383667e402e6cbd09.js" type="text/javascript" />
    </Helmet>
  );
}
